import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Divider, Tabs, Button, Modal, Rate, Skeleton, Typography, Tooltip, Popover } from 'antd';
import { FaMapMarkedAlt, FaCalendarAlt, FaBed, FaRegUser, FaHotel, FaChild, FaPhone, FaInfoCircle, FaUsers } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import { locationImg, getAmenityImg, getTopAmenities, formatCancellationPolicies, getCombinedAmenitiesToDisplay } from '../../../utils/ImagePath';

const HotelReviewTbo = ({
    loading,
    hotelDetails,
    startDate,
    endDate,
    totalNOAdults,
    totalNOChildren,
    totalRooms,
    extractBedType,
    roomSize,
    ResultIndex,
    vendor
}) => {
    const navigate = useNavigate();
    const { Text } = Typography;
    const [selectedRoomIndex, setSelectedRoomIndex] = useState(0);
    const [selectedRoomData, setSelectedRoomData] = useState(null);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [RoomDetailsTBO, setRoomDetailsTBO] = useState(null);
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [isModalOpenTBO, setIsModalOpenTBO] = useState(false);
    const maxItemsToShow = 10;
    const words = hotelDetails?.HotelInfoResult?.HotelDetails?.Description?.split(" ") || [];
    const displayedText = showFullDescription
        ? hotelDetails?.HotelInfoResult?.HotelDetails?.Description
        : words?.slice(0, 100).join(" ") + (words?.length > 100 ? "..." : "");
    const itemsToShowTBO = showFullDescription ? hotelDetails?.HotelInfoResult?.HotelDetails?.HotelFacilities :
        hotelDetails?.HotelInfoResult?.HotelDetails?.HotelFacilities?.slice(0, maxItemsToShow);

    const handleNavigate = () => {
        navigate("/hotel-payment", { state: { selectedRoomData, hotelDetails, resultIndex, vendor } });
    };

    const showModal2 = (room) => {
        setIsModalOpen2(true);
        setRoomDetailsTBO(room)
    };
    const handleOk2 = () => {
        setIsModalOpen2(false);
    };
    const handleCancel2 = () => {
        setIsModalOpen2(false);
    };

    const galleryImagesTBO = hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.map((url) => {
        return {
            original: url,
            thumbnail: url,
        };
    });

    const galleryOptions = {
        showFullscreenButton: true,
        showPlayButton: true,
        autoPlay: false,
        slideInterval: 2000,
    };

    const getWiFiAmenity = (amenity) => {
        return amenity.find(item =>
            /wifi/i.test(item)
        ) || null;
    };

    const getACAmenity = (amenity) => {
        return amenity.find(item =>
            /conditioning/i.test(item)
        ) || null;
    };

    const getRoomService = (inclusions) => {
        return inclusions.find(item =>
            /room\s*service(\s*\(?24.*\)?)?/i.test(item)
        ) || null;
    };

    const getCashbackPolicy = (policies) => {
        return policies?.find(policy => policy.ChargeType === 1);
    };

    const toggleDescription = () => {
        setShowFullDescription((prevState) => !prevState);
    };

    const htlAmenities = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px'
    };

    const htlAmenitiesItem = {
        display: 'flex',
        alignItems: 'center'
    };

    const htlAmenitiesItemIconWrap = {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginRight: '10px',
        width: '24px'
    };

    const htlAmenitiesItemIconWrapImg = {
        maxWidth: '16px'
    }

    const htlAmenitiesItemText = {
        maxWidth: '150px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    };

    const [showAllTBO, setShowAllTBO] = useState(false);

    const handleToggleShowAllTBO = () => {
        setShowAllTBO((prevState) => !prevState);
    };

    useEffect(() => {
        if (hotelDetails?.GetHotelRoomResult?.HotelRoomsDetails?.length > 0) {
            setSelectedRoomData(hotelDetails.GetHotelRoomResult.HotelRoomsDetails[0]);
        }
    }, [hotelDetails]);

    const handleSelect = (room, index) => {
        setSelectedRoomIndex(index);
        setSelectedRoomData(room);
    };

    let resultIndex = ResultIndex;

    useEffect(() => {
        Fancybox.bind("[data-fancybox]", {});
        return () => {
            Fancybox.destroy();
        };
    }, []);

    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };


    return (
        <>
            <section className="container-fluid hotel_confirm mb-4">
                <div className='container'>
                    <Row gutter={16} className="mb-4 mt-4 hotel_confirm_images">
                        <>
                            <Col md={12} xs={24} className='d-md-block d-none'>
                                {loading ? (
                                    <Skeleton.Image active className="w-100" style={{ height: '435px' }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[0]}>
                                        <img
                                            src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[0]}
                                            alt="Hotel"
                                            className="img-fluid rounded"
                                            style={{ height: '435px' }}
                                        />
                                    </a>
                                )}
                            </Col>

                            <Col md={6} xs={24} className='d-md-block d-none'>
                                {loading ? (
                                    <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[1]}>
                                        <img
                                            src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[1]}
                                            className="img-fluid rounded"
                                        />
                                    </a>
                                )}
                                {loading ? (
                                    <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[2]}>
                                        <img
                                            src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[2]}
                                            className="img-fluid rounded"
                                        />
                                    </a>
                                )}
                            </Col>

                            <Col md={6} xs={24}>
                                {loading ? (
                                    <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[3]}>
                                        <img
                                            src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[3]}
                                            className="img-fluid rounded d-md-inline d-none"
                                        />
                                    </a>
                                )}

                                <div className="more_photos position-relative">
                                    {loading ? (
                                        <Skeleton.Image active={true} className="w-100 mb-2" style={{ height: '210px' }} />
                                    ) : (
                                        <>
                                            <a data-fancybox="dynamic-gallery" href={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[4]}>
                                                <img
                                                    src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[4]}
                                                    className="img-fluid rounded"
                                                />
                                            </a>

                                            {hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.map((img, index) => (
                                                <a
                                                    key={index}
                                                    data-fancybox="dynamic-gallery"
                                                    href={img}
                                                    style={{ display: 'none' }}
                                                >
                                                    <img src={img} alt={`Hotel ${index}`} />
                                                </a>
                                            ))}

                                            <a
                                                type="primary"
                                                data-fancybox="dynamic-gallery" href={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[5]}
                                                className="position-absolute d-flex align-items-center"
                                            >
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='me-1'><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18.5116 10.0767C18.5116 10.8153 17.8869 11.4142 17.1163 11.4142C16.3457 11.4142 15.7209 10.8153 15.7209 10.0767C15.7209 9.33801 16.3457 8.7392 17.1163 8.7392C17.8869 8.7392 18.5116 9.33801 18.5116 10.0767Z" fill="#ffffff"></path> <path fillRule="evenodd" clipRule="evenodd" d="M18.0363 5.53205C16.9766 5.39548 15.6225 5.39549 13.9129 5.39551H10.0871C8.37751 5.39549 7.02343 5.39548 5.9637 5.53205C4.87308 5.6726 3.99033 5.96873 3.29418 6.63601C2.59803 7.30329 2.28908 8.14942 2.14245 9.19481C1.99997 10.2106 1.99999 11.5085 2 13.1472V13.2478C1.99999 14.8864 1.99997 16.1843 2.14245 17.2001C2.28908 18.2455 2.59803 19.0916 3.29418 19.7589C3.99033 20.4262 4.87307 20.7223 5.9637 20.8629C7.02344 20.9994 8.37751 20.9994 10.0871 20.9994H13.9129C15.6225 20.9994 16.9766 20.9994 18.0363 20.8629C19.1269 20.7223 20.0097 20.4262 20.7058 19.7589C21.402 19.0916 21.7109 18.2455 21.8575 17.2001C22 16.1843 22 14.8864 22 13.2478V13.1472C22 11.5085 22 10.2106 21.8575 9.19481C21.7109 8.14942 21.402 7.30329 20.7058 6.63601C20.0097 5.96873 19.1269 5.6726 18.0363 5.53205ZM6.14963 6.8576C5.21373 6.97821 4.67452 7.2044 4.28084 7.58175C3.88716 7.95911 3.65119 8.47595 3.52536 9.37303C3.42443 10.0926 3.40184 10.9919 3.3968 12.1682L3.86764 11.7733C4.99175 10.8305 6.68596 10.8846 7.74215 11.897L11.7326 15.7219C12.1321 16.1049 12.7611 16.1571 13.2234 15.8457L13.5008 15.6589C14.8313 14.7626 16.6314 14.8664 17.8402 15.9092L20.2479 17.9862C20.3463 17.7222 20.4206 17.4071 20.4746 17.0219C20.6032 16.1056 20.6047 14.8977 20.6047 13.1975C20.6047 11.4972 20.6032 10.2893 20.4746 9.37303C20.3488 8.47595 20.1128 7.95911 19.7192 7.58175C19.3255 7.2044 18.7863 6.97821 17.8504 6.8576C16.8944 6.73441 15.6343 6.73298 13.8605 6.73298H10.1395C8.36575 6.73298 7.10559 6.73441 6.14963 6.8576Z" fill="#ffffff"></path> <g opacity="0.5"> <path d="M17.0866 2.61039C16.2268 2.49997 15.1321 2.49998 13.7675 2.5H10.6778C9.31314 2.49998 8.21844 2.49997 7.35863 2.61039C6.46826 2.72473 5.72591 2.96835 5.13712 3.53075C4.79755 3.8551 4.56886 4.22833 4.41309 4.64928C4.91729 4.41928 5.48734 4.28374 6.12735 4.20084C7.21173 4.06037 8.5973 4.06038 10.3466 4.06039H14.2615C16.0108 4.06038 17.3963 4.06037 18.4807 4.20084C19.0397 4.27325 19.5453 4.38581 20.0003 4.56638C19.8457 4.17917 19.6253 3.83365 19.3081 3.53075C18.7193 2.96835 17.977 2.72473 17.0866 2.61039Z" fill="#ffffff"></path> </g> </g></svg> See more photos
                                            </a>
                                        </>
                                    )}
                                </div>
                            </Col>
                        </>

                    </Row>
                </div>
            </section>

            <div className='container'>
                <Row gutter={16}>
                    <Col lg={17} xs={24} className='pb-5 pb-md-0 mb-4 mb-md-0'>
                        <Skeleton
                            paragraph={{ rows: 10, }}
                            loading={loading}
                            style={{ background: "#fff" }}
                            className='p-4 mb-4'
                        >
                            <Card className="card mb-4" loading={loading}>
                                <Row className='flex-row-reverse'>
                                    <Col md={8} xs={24} className='mb-2 d-md-block d-none'>
                                        <a href={hotelDetails?.mapLinks} target='_blank'>
                                            <div className='large_Responsive'>
                                                {hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.length === 1 && (
                                                    <img
                                                        src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[0]}
                                                        alt="Hotel"
                                                        className="img-fluid rounded float-end"
                                                    />
                                                )}
                                                <a href={hotelDetails?.mapLinks} target='_blank'><img src={locationImg} alt='location-img' width={'50px'} /> </a>
                                            </div>
                                        </a>
                                    </Col>

                                    <Col md={16} xs={24}>
                                        <h2 className='mb-2'>{hotelDetails?.HotelInfoResult?.HotelDetails?.HotelName}</h2>
                                        <div className="ratings d-flex align-items-center gap-2 mb-3">
                                            <div className="d-flex align-items-center">
                                                <ul className="d-flex align-items-center gap-1 p-0 m-0">
                                                    <Rate disabled value={hotelDetails?.HotelInfoResult?.HotelDetails?.StarRating} />
                                                </ul>
                                                <span className="ms-2">{hotelDetails?.hotel?.pt}</span>
                                            </div>
                                            |
                                            <div>
                                                <b className="bg-success px-2 rounded text-white">{hotelDetails?.HotelInfoResult?.HotelDetails?.StarRating}/5</b>
                                                <p className="d-none d-md-inline mb-0 ms-2">Ratings</p>
                                            </div>
                                        </div>
                                        <h4 className='fw-normal mb-1'><FaMapMarkedAlt className="me-1" />{hotelDetails?.HotelInfoResult?.HotelDetails?.Address}</h4>
                                        {hotelDetails?.HotelInfoResult?.HotelDetails?.HotelContactNo && <h4 className='fw-normal'><FaPhone className="me-1" />{hotelDetails?.HotelInfoResult?.HotelDetails?.HotelContactNo}</h4>}
                                    </Col>

                                </Row>
                                <Tabs
                                    defaultActiveKey="rooms"
                                    type="card"
                                    className="custom-tabs mt-4"
                                    tabBarStyle={{
                                        borderBottom: "2px solid #d9d9d9",
                                    }}
                                    tabBarExtraContent={{
                                        style: {
                                            margin: "0 auto",
                                        },
                                    }}
                                    items={[
                                        {
                                            label: "Rooms",
                                            key: "rooms",
                                            children: (
                                                <div className="rooms">
                                                    <h4 className='my-4'>Choose your room</h4>
                                                    <div className="room-selection" >
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                            {hotelDetails?.GetHotelRoomResult?.HotelRoomsDetails?.map((room, index) => (
                                                                <Card
                                                                    onClick={() => handleSelect(room, index)}
                                                                    key={room.RoomIndex}
                                                                    className='cursor-pointer'
                                                                    style={{ boxShadow: selectedRoomIndex === index ? "0px 0px 0px 2px #00378F" : "0px 0px 0px 1px #d9d9d9" }}>
                                                                    {(() => {
                                                                        const roomTypeName = room?.RoomTypeName?.split(',') || [];
                                                                        const roomNameHeading = roomTypeName[0] || '';
                                                                        const roomBedType = roomTypeName.find(part => /bed/i.test(part)) || '';
                                                                        window._extractedBedType = roomBedType;

                                                                        return <h3 className='border-bottom pb-2 mb-2'>{roomNameHeading}</h3>;
                                                                    })()}
                                                                    {(() => {
                                                                        const html = room?.RoomDescription || '';
                                                                        const parser = new DOMParser();
                                                                        const doc = parser.parseFromString(html, 'text/html');
                                                                        const allParagraphs = Array.from(doc.querySelectorAll('p'));
                                                                        let roomSize = '';
                                                                        const wantedLabels = ['Executive Level', 'Comfort', 'Accessibility', 'Practical', 'Bathroom', 'Food and Drink'];
                                                                        const selectedData = allParagraphs
                                                                            .map(p => p.innerHTML.trim())
                                                                            .filter(p => {
                                                                                if (p.match(/\d+\s*sq\s*feet/i)) {
                                                                                    roomSize = p;
                                                                                    return false;
                                                                                }
                                                                                return wantedLabels.some(label => p.startsWith(`<b>${label}</b>`));
                                                                            });
                                                                        return (
                                                                            <>
                                                                                <div className="room-info-details mb-3">
                                                                                    {selectedData.map((item, index) => (
                                                                                        <p style={{ fontSize: "14px" }} key={index} dangerouslySetInnerHTML={{ __html: item }}></p>
                                                                                    ))}
                                                                                </div>

                                                                            </>
                                                                        );
                                                                    })()}
                                                                    <h3 className='border-bottom pb-2 mb-2'>Most popular facilities <img style={{ ...htlAmenitiesItemIconWrapImg, position: "relative", left: "2px" }} src='/images/amenities/default.webp' /></h3>
                                                                    <div className='d-lg-flex align-items-center'>
                                                                        <div className='Amenitis_cntr w-100 d-md-flex'>
                                                                            <ul>
                                                                                {room?.Inclusion?.filter(item => item != 'Room Only')?.map((item, index) => (
                                                                                    <li data-testid={`inclusion-item-${index}`} key={index}>
                                                                                        <img style={{ ...htlAmenitiesItemIconWrapImg }} src={getAmenityImg(item)} alt={item} title={item} />
                                                                                        <span style={{ width: '220px' }} title={item}>{item}</span>
                                                                                    </li>
                                                                                ))}
                                                                                {(() => {
                                                                                    const filteredInclusions = room?.Inclusion?.filter(item => item !== 'Room Only') || [];
                                                                                    const totalInclusion = filteredInclusions.length;
                                                                                    const amenityFirstColumn = getTopAmenities(room?.Amenity || [], 0, 4 - totalInclusion);
                                                                                    return amenityFirstColumn.map((item, index) => (
                                                                                        <li data-testid={`inclusion-item-${index}`} key={index}>
                                                                                            <img
                                                                                                style={{ ...htlAmenitiesItemIconWrapImg }}
                                                                                                src={getAmenityImg(item?.image)}
                                                                                                alt={item?.label}
                                                                                                title={item?.label}
                                                                                            />
                                                                                            <span style={{ width: '220px' }} title={item?.label}>
                                                                                                {item?.label}
                                                                                            </span>
                                                                                        </li>
                                                                                    ));
                                                                                })()}
                                                                            </ul>

                                                                            <ul className='center_amenities mt-md-0 mt-3'>
                                                                                {(() => {
                                                                                    const cashbackPolicy = getCashbackPolicy(room?.CancellationPolicies);
                                                                                    const cleanText = room?.CancellationPolicy?.replace('.|#!#', '').trim();
                                                                                    let percent = '';
                                                                                    let fromDateStr = '';
                                                                                    let toDateStr = '';
                                                                                    let formatDateWithIST = (dateStr) => '';

                                                                                    const match = cleanText?.match(/([\d.]+%) of total amount will be charged.*between (.+?) and (.+?)$/i);

                                                                                    if (match) {
                                                                                        [, percent, fromDateStr, toDateStr] = match;
                                                                                        formatDateWithIST = (dateStr) => {
                                                                                            const date = new Date(dateStr + ' GMT+0530'); // Ensure IST
                                                                                            return date.toLocaleDateString('en-IN', {
                                                                                                year: 'numeric',
                                                                                                month: 'long',
                                                                                                day: 'numeric',
                                                                                            }) + ' IST';
                                                                                        };
                                                                                    }

                                                                                    // If no cashback but has cancellation policy
                                                                                    if (!cashbackPolicy && match) {
                                                                                        const formattedText = `${percent} of the total amount will be charged if cancelled between ${formatDateWithIST(fromDateStr)} and ${formatDateWithIST(toDateStr)} (inclusive).`;
                                                                                        return (
                                                                                            <li>
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                                                    <path d="M9.75 15.75H4.5C4.10218 15.75 3.72064 15.592 3.43934 15.3107C3.15804 15.0294 3 14.6478 3 14.25V5.25C3 4.85218 3.15804 4.47064 3.43934 4.18934C3.72064 3.90804 4.10218 3.75 4.5 3.75H13.5C13.8978 3.75 14.2794 3.90804 14.5607 4.18934C14.842 4.47064 15 4.85218 15 5.25V10.125M12 2.25V5.25M6 2.25V5.25M3 8.25H15M16.5 16.5L12.75 12.75M12.75 16.5L16.5 12.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                </svg>
                                                                                                Non-Refundable
                                                                                                <Tooltip title={formattedText}>
                                                                                                    <FaInfoCircle className="mx-1" />
                                                                                                </Tooltip>
                                                                                            </li>
                                                                                        );
                                                                                    }

                                                                                    // If cashback is available
                                                                                    if (cashbackPolicy?.ToDate) {
                                                                                        const cashbackPolicy = getCashbackPolicy(room?.CancellationPolicies);
                                                                                        const rawText = room?.CancellationPolicy || '';
                                                                                        const formattedPolicies = formatCancellationPolicies(rawText);
                                                                                        const toDateObj = new Date(cashbackPolicy.ToDate);
                                                                                        const time = toDateObj.toLocaleTimeString('en-IN', {
                                                                                            hour: '2-digit',
                                                                                            minute: '2-digit',
                                                                                            second: '2-digit',
                                                                                            hour12: false,
                                                                                        });
                                                                                        const date = toDateObj.toLocaleDateString('en-IN', {
                                                                                            day: '2-digit',
                                                                                            month: 'short',
                                                                                        })

                                                                                        // Parse and format multiple policies
                                                                                        const formatDate = (dateStr) => {
                                                                                            const date = new Date(dateStr + ' GMT+0530');
                                                                                            return date.toLocaleDateString('en-IN', {
                                                                                                year: 'numeric',
                                                                                                month: 'long',
                                                                                                day: 'numeric',
                                                                                            }) + ' (IST)';
                                                                                        };
                                                                                        return (
                                                                                            <li>
                                                                                                <img
                                                                                                    style={{ ...htlAmenitiesItemIconWrapImg }}
                                                                                                    src={getAmenityImg('money-back')}
                                                                                                    alt="cashback"
                                                                                                />
                                                                                                100% Cashback till {time}, {date}
                                                                                                <Tooltip
                                                                                                    title={
                                                                                                        <div style={{ whiteSpace: 'pre-line' }}>
                                                                                                            {formattedPolicies.join('\n')}
                                                                                                        </div>
                                                                                                    }
                                                                                                >
                                                                                                    <FaInfoCircle className="mx-1" />
                                                                                                </Tooltip>
                                                                                            </li>
                                                                                        );
                                                                                    }

                                                                                    return null;
                                                                                })()}

                                                                                {getCombinedAmenitiesToDisplay(room?.Amenity || [], room?.Inclusion || [], getTopAmenities, 3).map((item, index) => (
                                                                                    <li data-testid={`inclusion-item-${index}`} key={index}>
                                                                                        <img
                                                                                            style={{ ...htlAmenitiesItemIconWrapImg }}
                                                                                            src={getAmenityImg(item.image)}
                                                                                            alt={item.label}
                                                                                            title={item.label}
                                                                                        />
                                                                                        <span style={{ width: '220px' }} title={item.label}>
                                                                                            {item.label}
                                                                                        </span>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>

                                                                        <div className='ms-lg-3 d-lg-flex mt-lg-0 mt-3' style={{ flexDirection: "column", alignItems: "flex-end" }}>
                                                                            <div className='d-flex align-items-center gap-2'>
                                                                                <p className='text-decoration-line-through lh-sm'>
                                                                                    ₹{Math.round(room?.Price?.TotalPublishFare)}
                                                                                </p>
                                                                                <span className=' lh-sm' style={{ fontSize: "16px", fontWeight: "bold" }}>
                                                                                    ₹{Math.round(room.Price?.PublishedPriceRoundedOff)}
                                                                                </span>
                                                                            </div>
                                                                            <p style={{ fontSize: '11px', fontWeight: '500' }} className='mt-1 mb-2 lh-sm'>+₹{Math.round(room.Price?.ServiceTax)} taxes & <br /> fees per night</p>
                                                                            <button
                                                                                type={selectedRoomIndex === index ? "primary" : "default"}
                                                                                onClick={() => handleSelect(room, index)}
                                                                                className="btn btn-dark w-100 text-center fw-bold fs-6"
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        selectedRoomIndex === index ? "var(--primary-color)" : "#fff",
                                                                                    border:
                                                                                        selectedRoomIndex === index
                                                                                            ? "1px solid #00378F"
                                                                                            : "1px solid var(--primary-color)",
                                                                                    color:
                                                                                        selectedRoomIndex === index ? "#fff" : "var(--primary-color)",
                                                                                    padding: "10px 0px",
                                                                                }}
                                                                                aria-label="Select"
                                                                            >
                                                                                {selectedRoomIndex === index ? "Selected" : "Select"}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <button
                                                                        onClick={() => showModal2(room)}
                                                                        className='border-0 bg-white p-0 text-primary mt-3'>
                                                                        Room Details
                                                                    </button>

                                                                </Card>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            ),
                                        },
                                        {
                                            label: "Overview",
                                            key: "overview",
                                            children: (
                                                <div className="overview">
                                                    <div>
                                                        <h4 className="mb-2">Hotel Description</h4>
                                                        <div>
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: displayedText,
                                                                }}
                                                            />
                                                            {words?.length > 100 && (
                                                                <button
                                                                    type="button"
                                                                    className="read-more-button"
                                                                    onClick={toggleDescription}
                                                                    style={{
                                                                        marginLeft: "10px",
                                                                        color: "#007bff",
                                                                        background: "none",
                                                                        border: "none",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    aria-label="Read more"
                                                                >
                                                                    {showFullDescription ? "Show Less" : "Read More"}
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <h4 className='mb-2 mt-4'>Hotel Facilities</h4>
                                                    <div>
                                                        <ul className="Hotel_services">

                                                            {itemsToShowTBO?.map((item, index) => (
                                                                <li key={index}>{item}</li>
                                                            ))}
                                                        </ul>

                                                        {hotelDetails?.HotelInfoResult?.HotelDetails?.HotelFacilities?.length > maxItemsToShow && (
                                                            <button
                                                                type="button"
                                                                className="read-more-button"
                                                                onClick={handleToggleShowAllTBO}
                                                                aria-label="show less"
                                                            >
                                                                {showAllTBO ? "Show Less" : "Read More"}
                                                            </button>
                                                        )}
                                                    </div>

                                                    <div className="mt-4">
                                                        <h4 className="mb-2">Hotel Policy</h4>
                                                        <div>
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: hotelDetails?.HotelInfoResult?.HotelDetails?.HotelPolicy,
                                                                }}
                                                            />
                                                        </div>
                                                        <Divider />

                                                    </div>

                                                    <Divider />
                                                </div>
                                            ),
                                        },

                                        {
                                            label: "Amenities",
                                            key: "amenities",
                                            children: (
                                                <div className="amenities">
                                                    <h4 className="my-4">Amenities</h4>
                                                    <ul className="amenities-list" style={{ ...htlAmenities }}>
                                                        {selectedRoomData?.Amenity?.length > 0 ? (
                                                            selectedRoomData.Amenity.map((item, index) => (
                                                                <li className="htlAmenities__item" style={{ ...htlAmenitiesItem }} data-testid={`amenity-item-${index}`} key={index}>
                                                                    <span className="htlAmenities__itemIconWrap" style={{ ...htlAmenitiesItemIconWrap }}>
                                                                        <img style={{ ...htlAmenitiesItemIconWrapImg }} src={getAmenityImg(item)} alt={item} title={item} />
                                                                    </span>
                                                                    <span className="htlAmenities__itemText" style={{ ...htlAmenitiesItemText }} title={item}>{item}</span>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <p>No amenities available.</p>
                                                        )}
                                                    </ul>
                                                </div>
                                            ),
                                        },
                                    ]}
                                />
                            </Card>
                        </Skeleton>
                    </Col>
                    <Col lg={7} xs={24} className='w-100'>
                        <Skeleton
                            paragraph={{ rows: 10, }}
                            loading={loading}
                            style={{ background: "#fff" }}
                            className='p-4 mb-4'
                        >
                            <Card
                                className="hotel-confirm-card hotel_confirm_cntr mb-md-4"
                                style={{
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <div className='d-md-block d-none'>
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-container bg-light border py-1 px-2 rounded">
                                            <FaHotel size={20} />
                                        </div>
                                        <p className="room-type mb-0 ms-2 fw-bold text-truncate" style={{ fontSize: "1rem" }}>
                                            {selectedRoomData?.RoomTypeName || "Room Type"}
                                        </p>
                                    </div>

                                    <div className="date-info mb-3 bg-light-primary px-2 py-2 rounded">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <FaCalendarAlt size={18} className="text-primary" />
                                            <span>Check-in: {startDate}</span>
                                        </div>
                                        <Divider className="my-2" />
                                        <div className="d-flex align-items-center gap-2">
                                            <FaCalendarAlt size={18} className="text-primary" />
                                            <span>Check-out: {endDate}</span>
                                        </div>
                                    </div>

                                    <Divider className="my-3" />
                                    <div className="room-details">
                                        <div className="d-flex justify-content-between">
                                            <h4>
                                                <FaRegUser className="me-2 text-secondary" />
                                                <span>{totalNOAdults} Adult{totalNOAdults > 1 ? "s" : ""}</span>
                                            </h4>
                                            <h4>
                                                <FaChild className="me-2 text-secondary" />
                                                {totalNOChildren} Child{totalNOChildren > 1 ? "ren" : ""}
                                            </h4>
                                        </div>
                                        <div className="d-flex justify-content-between mt-2">
                                            <h3>{totalRooms} Total Room{totalRooms > 1 ? "s" : ""}</h3>
                                        </div>
                                    </div>
                                    <Divider className="my-3" />
                                    <div className="card-body">
                                        <>
                                            <div className='bg-light-primary p-2 rounded'>
                                                <div className="d-flex align-items-center justify-content-between pb-1">
                                                    <Text>Base Fare</Text>
                                                    <Text><b>₹{Math.round(selectedRoomData?.Price?.TotalPublishFare * totalRooms)}/-</b></Text>
                                                </div>
                                                <hr />
                                                <div className="d-flex align-items-center justify-content-between mt-1 pb-1">
                                                    <Text>Total Discount</Text>
                                                    <Text><b className='text-danger'>₹{Math.round(selectedRoomData?.Price?.discountAmount * totalRooms)}/-</b></Text>
                                                </div>
                                                <hr />
                                                <div className="d-flex align-items-center justify-content-between  mt-1 pb-1">
                                                    <Text>Price after Discount</Text>
                                                    <Text><b>₹{Math.round(selectedRoomData?.Price?.PublishedPriceRoundedOff * totalRooms)}/-</b></Text>
                                                </div>
                                                <hr />
                                                <div className="d-flex align-items-center justify-content-between  mt-1">
                                                    <Text>Taxes & Fees </Text>
                                                    <Text><b>₹{Math.round(selectedRoomData?.Price?.ServiceTax * totalRooms)}/-</b></Text>
                                                </div>
                                                <hr />
                                                {/* <div className="d-flex align-items-center justify-content-between  mt-1">
                                                            <div>
                                                                <Text> Redeem Points</Text>
                                                                <Checkbox className="mx-2" onChange={handleChange} checked={isRedeem} />
                                                            </div>
                                                            {discountAmount !== 0 && <Text><b>₹{Math.round(discountAmount)}/-</b></Text>}
                                                        </div> */}

                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                                                <p className="text-muted mb-0">Total Price :</p>
                                                <p className="mb-0 fw-bold text-success" style={{ fontSize: "1.2rem" }}>
                                                    ₹{Math.round(
                                                        (selectedRoomData?.Price?.PublishedPriceRoundedOff * totalRooms || 0) +
                                                        (selectedRoomData?.Price?.ServiceTax * totalRooms || 0)
                                                    )}
                                                    {/* ₹{Math.round(totalPrice)} */}
                                                </p>
                                            </div>
                                        </>
                                    </div>

                                    <button
                                        className="btn btn-primary w-100 border-0 fw-bold fs-6"
                                        style={{
                                            borderRadius: "4px",
                                            padding: "10px 0",
                                        }}
                                        onClick={handleNavigate}
                                        aria-label="continue"
                                    >
                                        Book This Now
                                    </button>

                                </div>
                            </Card>
                        </Skeleton>

                        <Card
                            className="hotel-confirm-card hotel_confirm_cntr mb-md-4  d-md-none"
                            style={{
                                borderRadius: "8px",
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <div className='footer-price d-md-none'>
                                <div className='footer-price-content'>
                                    {loading ? (
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="spinner"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <div>
                                                <h2 className="fw-bold d-flex align-items-center gap-2">
                                                    ₹{Math.round(
                                                        (selectedRoomData?.Price?.PublishedPriceRoundedOff || 0) +
                                                        (selectedRoomData?.Price?.ServiceTax || 0)
                                                    )}
                                                    <Popover
                                                        content={
                                                            <div>
                                                                {selectedRoomData?.Price?.TotalPublishFare !== 0 ?
                                                                    <>
                                                                        <div>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Base Fare: </Text>
                                                                                <Text><b>₹{Math.round(selectedRoomData?.Price?.TotalPublishFare)}/-</b></Text>
                                                                            </div>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Total Discount: </Text>
                                                                                <Text><b className='text-danger'>₹{Math.round(selectedRoomData?.Price?.discountAmount)}/-</b></Text>
                                                                            </div>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Price after Discount: </Text>
                                                                                <Text className='ms-1'><b>₹{Math.round(selectedRoomData?.Price?.PublishedPriceRoundedOff)}/-</b></Text>
                                                                            </div>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Taxes & Fees: </Text>
                                                                                <Text><b>₹{Math.round(selectedRoomData?.Price?.ServiceTax)}/-</b></Text>
                                                                            </div>
                                                                        </div>
                                                                    </>

                                                                    :
                                                                    <>
                                                                        <div className='bg-light-primary p-2 rounded'>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Base Fare: </Text>
                                                                                <Text>₹{Math.round(selectedRoomData?.Price?.PublishedPriceRoundedOff)}/-</Text>
                                                                            </div>
                                                                            <hr />
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Taxs & Fees: </Text>
                                                                                <Text>₹{Math.round(nights * selectedRoomData?.Price?.ServiceTax)}/-</Text>
                                                                            </div>
                                                                        </div>

                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                            <Text>Redeem: </Text>
                                                                            <Checkbox onChange={handleChange} checked={isReedom}>
                                                                                Redeem Discount
                                                                            </Checkbox>
                                                                        </div>

                                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                                            <p className="text-muted mb-0"></p>
                                                                            <p className="mb-0 fw-bold text-success" style={{ fontSize: "1.2rem" }}>

                                                                            </p>
                                                                        </div>
                                                                    </>
                                                                }
                                                                <div className="text-center mt-2 bg-light-success p-1 rounded">
                                                                    <h3 className='d-flex justify-content-between'>Total Price:
                                                                        <span className='ms-1 fw-bold'>
                                                                            ₹{Math.round(
                                                                                (selectedRoomData?.Price?.PublishedPriceRoundedOff || 0) +
                                                                                (selectedRoomData?.Price?.ServiceTax || 0)
                                                                            )}
                                                                        </span>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        }
                                                        title="Payment Detail"
                                                        trigger="click"
                                                        open={open}
                                                        onOpenChange={handleOpenChange}
                                                        className="booking-filter"
                                                    >
                                                        <span><FaInfoCircle /></span>
                                                    </Popover>
                                                </h2>
                                                <p>
                                                    {totalRooms} Room{totalRooms > 1 ? "s" : ""}
                                                    &nbsp;For
                                                    {(() => {
                                                        const adults = totalNOAdults || 0;
                                                        const children = totalNOChildren || 0;
                                                        const totalGuest = adults + children;
                                                        return ` ${totalGuest} `;
                                                    })()}
                                                    Guest
                                                </p>
                                            </div>
                                        </>
                                    )}

                                    <button
                                        className="btn bg-light-primary text-primary d-inline-block float-end rounded my-3 px-4 fw-bold fs-6"
                                        style={{
                                            borderRadius: "4px 4px 0 0",
                                            fontWeight: "bold",
                                            padding: "10px 0",
                                            height: "45px",
                                            cursor: loading ? "not-allowed" : "pointer",
                                            opacity: loading ? 0.7 : 1,
                                        }}
                                        onClick={loading ? null : handleNavigate}
                                        disabled={loading}
                                        aria-label="Couninue"
                                    >
                                        Book This Now
                                    </button>
                                </div>
                            </div>
                        </Card>
                    </Col>

                </Row>
            </div >


            <div className='hotel-gallery tbo'>
                <Modal
                    className='Gallery_cntr p-0'
                    open={isModalOpenTBO}
                    footer={null}
                    onCancel={() => setIsModalOpenTBO(false)}
                    centered
                    width={1000}
                    destroyOnClose={true}
                >
                    <div className="gallery-container">
                        <ImageGallery
                            items={galleryImagesTBO}
                            showThumbnails={true}
                            showBullets={true}
                            {...galleryOptions}
                        />
                    </div>
                </Modal>
            </div>

            <Modal
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen2}
                onOk={handleOk2}
                onCancel={handleCancel2}
                width={750}
                className='room-details-modal'
            >
                <div className='room-details-cntr d-md-flex align-items-center gap-3 mb-md-3'>
                    <img src={hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[0]} alt="room images" />
                    <div className='mb-md-0 mb-3'>
                        {(() => {
                            const roomTypeParts = RoomDetailsTBO?.RoomTypeName?.split(',') || [];
                            const roomName = roomTypeParts[0] || '';
                            const bedType = roomTypeParts.find(part => /bed/i.test(part)) || '';
                            window._extractedBedType = bedType;
                            return <h2 className='mb-2 pe-5'>{roomName}</h2>;
                        })()}
                        {(() => {
                            const html = RoomDetailsTBO?.RoomDescription || '';
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');
                            const allParagraphs = Array.from(doc.querySelectorAll('p'));
                            let roomSize = '';
                            const wantedLabels = ['Executive Level', 'Comfort', 'Accessibility', 'Practical', 'Bathroom', 'Food and Drink'];
                            const selectedData = allParagraphs
                                .map(p => p.innerHTML.trim())
                                .filter(p => {
                                    if (p.match(/\d+\s*sq\s*feet/i)) {
                                        roomSize = p;
                                        return false;
                                    }
                                    return wantedLabels.some(label => p.startsWith(`<b>${label}</b>`));
                                });

                            return (
                                <>
                                    <div className="room-info-details mb-3">
                                        {selectedData.map((item, index) => (
                                            <p key={index} dangerouslySetInnerHTML={{ __html: item }}></p>
                                        ))}
                                    </div>

                                </>
                            );
                        })()}

                        <div className='bg-gray d-flex align-items-center gap-md-4 gap-3'>
                            <p className="d-flex align-items-center gap-2 m-0 fw-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.00001C6.93913 4.00001 5.92172 4.42144 5.17157 5.17159C4.42143 5.92173 4 6.93915 4 8.00001C4 9.06088 4.42143 10.0783 5.17157 10.8284C5.92172 11.5786 6.93913 12 8 12C9.06087 12 10.0783 11.5786 10.8284 10.8284C11.5786 10.0783 12 9.06088 12 8.00001C12 6.93915 11.5786 5.92173 10.8284 5.17159C10.0783 4.42144 9.06087 4.00001 8 4.00001ZM6 13C4.93913 13 3.92172 13.4214 3.17157 14.1716C2.42143 14.9217 2 15.9391 2 17V18C2 18.5304 2.21071 19.0392 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0392 14 18.5304 14 18V17C14 15.9391 13.5786 14.9217 12.8284 14.1716C12.0783 13.4214 11.0609 13 10 13H6ZM13.25 10.905C13.728 10.045 14 9.05501 14 8.00001C14.0002 6.98345 13.7421 5.9835 13.25 5.09401C13.8178 4.55674 14.5306 4.19763 15.3003 4.06104C16.07 3.92446 16.8628 4.0164 17.5808 4.3255C18.2988 4.6346 18.9106 5.14731 19.3403 5.80026C19.7701 6.45322 19.9992 7.2178 19.9992 7.99951C19.9992 8.78123 19.7701 9.54581 19.3403 10.1988C18.9106 10.8517 18.2988 11.3644 17.5808 11.6735C16.8628 11.9826 16.07 12.0746 15.3003 11.938C14.5306 11.8014 13.8178 11.4423 13.25 10.905ZM15.466 20C15.806 19.412 16.001 18.729 16.001 18V17C16.0028 15.5238 15.4586 14.099 14.473 13H18C19.0609 13 20.0783 13.4214 20.8284 14.1716C21.5786 14.9217 22 15.9391 22 17V18C22 18.5304 21.7893 19.0392 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H15.466Z" fill="black" />
                                </svg>
                                Max {roomSize} Guests
                            </p>
                            {window._extractedBedType && (
                                <p className='d-flex align-items-center gap-2 m-0 fw-bold w-100'><FaBed className='fs-4' /> <span>{window._extractedBedType}</span></p>
                            )}
                        </div>

                    </div>
                </div>


                {/* <p className='mb-3'
                    dangerouslySetInnerHTML={{
                        __html: RoomDetailsTBO?.RoomDescription,
                    }}>
                </p>  */}

                {RoomDetailsTBO?.Amenity?.length > 0 && (
                    <div>
                        <h3 className="mb-2">Amenities</h3>

                        {(() => {
                            const items = RoomDetailsTBO.Amenity;
                            const middle = Math.ceil(items.length / 2);
                            const column1 = items.slice(0, middle);
                            const column2 = items.slice(middle);

                            return (
                                <div className='RoomDetailsAmenities'>
                                    <ul>
                                        {column1.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                    <ul>
                                        {column2.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            );
                        })()}
                    </div>
                )}
            </Modal>
        </>
    );
};

export default HotelReviewTbo;